export default __webpack_public_path__ + "static/media/walletconnect-circle-blue.31c29967.svg";